import { createContext, useCallback, useContext, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useGenericModal } from "../../../../components/global/UniversalModal";

const SidePanelContext = createContext(null);

export const SidePanelContextProvider = ({ children }) => {
  const [panelContent, setPanelContent] = useState(null);
  const [containerEl, setContainerEl] = useState(null);
  const currentModalIdRef = useRef(null);
  const containerRef = useCallback((node) => setContainerEl(node), []);
  const { openGenericModal, closeGenericModal } = useGenericModal();

  const openPanel = useCallback(
    (portalContent, asModal = false) => {
      if (asModal) {
        const modalId = openGenericModal(() => portalContent);
        currentModalIdRef.current = modalId;
      } else {
        setPanelContent(portalContent);
      }
    },
    [openGenericModal]
  );

  const closePanel = useCallback(() => {
    if (currentModalIdRef.current) {
      closeGenericModal(currentModalIdRef.current);
      currentModalIdRef.current = null;
    } else {
      setPanelContent(null);
    }
  }, [closeGenericModal]);

  return (
    <SidePanelContext.Provider
      value={{ containerRef, panelContent, openPanel, closePanel }}
    >
      {children}
      {containerEl && panelContent && createPortal(panelContent, containerEl)}
    </SidePanelContext.Provider>
  );
};

export const useSidePanelPortal = () => {
  const context = useContext(SidePanelContext);
  if (!context) {
    throw new Error(
      "useSidePanelPortal must be used within a SidePanelContextProvider"
    );
  }

  return context;
};
